'use client'

import { ClientCrossSelling } from 'cross-selling/components/shared/CrossSelling/client/ClientCrossSelling'
import { useLastViewed } from 'cross-selling/contexts/LastViewedProvider/LastViewedProvider'
import type { HorizontalScrollTextProps } from 'fukku/HorizontalScroll/components/HorizontalScrollText/HorizontalScrollText'
import { useLabels } from 'labels/hooks/useLabels/useLabels'
import type { ImagesSizes } from 'product-card/context/ProductCardImagesSizesContext/ProductCardImagesSizesContext'
import type { ProductImageType } from 'product/types'
import type { ProductLocations } from 'product/types/ProductLocations'

import text from 'fukku/styles/texts.module.scss'

const imageSortCriteria: ProductImageType[] = ['B']

export interface LastViewedCrossSellingProps {
	dataTestId: string
	productCardImagesSizes: ImagesSizes[]
	title: string
	location: ProductLocations
}

export function LastViewedCrossSelling({
	dataTestId,
	productCardImagesSizes,
	title,
	location,
}: LastViewedCrossSellingProps): React.ReactNode {
	const { t } = useLabels()
	const { lastViewedProducts } = useLastViewed()

	const titleProps: HorizontalScrollTextProps = {
		content: t(title),
		className: text.uppercaseL,
	}

	return (
		!!lastViewedProducts?.length && (
			<ClientCrossSelling
				crossSellingItems={lastViewedProducts}
				data-testid={dataTestId}
				imageSortCriteria={imageSortCriteria}
				productCardImagesSizes={productCardImagesSizes}
				titleProps={titleProps}
				location={location}
			/>
		)
	)
}
